// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"635c822320c62b76b47c","293":"ff3e8c557d90444395dc","454":"2980f87c17f26afd343c"}[chunkId] + ".js";
};